import {
  Dropdown,
  Button,
  Select,
  Menu,
  Segmented,
  Input,
  Spin,
  Form,
  DatePicker,
  Typography,
  Card,
  Col,
  Row,
  Steps,
  InputNumber,
  Radio,
  TimePicker,
} from "antd";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import React, { useEffect, useRef, useState } from "react";

import TextArea from "antd/es/input/TextArea";
import moment from "moment";
const { RangePicker } = DatePicker;
const UpdateModal = ({
  open,
  handleClose,
  style,
  edit,
  form,
  onFinish,
  onFinishFailed,
}) => {
  //   console.log(edit);

  const inputRef = useRef(null);
  const { Title } = Typography;
  useEffect(() => {
    if (edit) {
      form.setFieldsValue({
        ...edit,
        eventDate: moment(edit?.eventDate),
        endDate: moment(edit?.endDate),
        startDate: moment(edit?.startDate),
        regStartDate: moment(edit?.regStartDate),
        eventTimeRange: edit?.eventTimeRange
          ? [moment(edit?.eventTimeRange[0], "HH:mm"), moment(edit?.eventTimeRange[1], "HH:mm")]
          : null,
      });
    }
  }, [edit, open]);

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Title level={4} style={{ display: "flex", justifyContent: "center" }}>
          Event Details
        </Title>
        <hr />
        <Form
          form={form}
          name="basic"
          className="custom-form"
          labelCol={{
            span: 24,
          }}
          wrapperCol={{
            span: 24,
          }}
          initialValues={{
            remember: true,
          }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        // onValuesChange={handleValuesChange}
        >
          <Form.Item
            style={{ marginBottom: "10px" }}
            name="eventName"
            label="Event Name"
            rules={[
              {
                required: true,
                message: "Enter event name!",
              },
            ]}
          >
            <Input
              size="large"
              placeholder="Enter event name"
              style={{
                border: '1px solid #d9d9d9', // Set a border to avoid global CSS issues
                borderRadius: '4px', // Rounded corners
                padding: '4px', // Padding for better spacing
                width: '100%', // Full width
                boxShadow: 'none', // Remove any shadow
                height: '40px', // Fixed height
              }}
            />
          </Form.Item>
          <Form.Item
            name="eventDate"
            label="Event Date"
            rules={[{ required: true, message: "Please select a event date!" }]}
          >
            <DatePicker
              getPopupContainer={(trigger) => trigger.parentNode}
              size="large"
              style={{ width: "100%" }}
            />
          </Form.Item>
          <Form.Item
            style={{ marginBottom: "10px" }}
            name="code"
            label="Code"
            rules={[
              {
                required: true,
                message: "Enter event code!",
              },
            ]}
          >
            <Input size="large" placeholder="Enter event code"
              style={{
                border: '1px solid #d9d9d9', // Set a border to avoid global CSS issues
                borderRadius: '4px', // Rounded corners
                padding: '4px', // Padding for better spacing
                width: '100%', // Full width
                boxShadow: 'none', // Remove any shadow
                height: '32px', // Fixed height
              }}
            />
          </Form.Item>
          <Form.Item
            style={{ marginBottom: "10px" }}
            name="registrationCount"
            label="Registration Count"
            rules={[
              {
                required: true,
                message: "Enter event registration count!",
              },
            ]}
          >
            <InputNumber
              size="large"
              style={{ width: "100%" }}
              placeholder="Enter event registration count"
            />
          </Form.Item>
          <Form.Item
            style={{ marginBottom: "10px" }}
            name="eventLimit"
            label="Registration Count Limit"
            rules={[
              {
                required: true,
                message: "Enter event registration count limit!",
              },
            ]}
          >
            <InputNumber
              size="large"
              style={{ width: "100%" }}
              placeholder="Enter event registration count limit"
            />
          </Form.Item>
          <Form.Item
            style={{ marginBottom: "10px" }}
            name="attendance"
            label="Attendance Count"
          // rules={[
          //   {
          //     required: true,
          //     message: "Enter event attendance count!",
          //   },
          // ]}
          >
            <InputNumber
              size="large"
              style={{ width: "100%" }}
              placeholder="Enter event attendance count"
            />
          </Form.Item>
          <Form.Item
            name="startDate"
            label="Event Start Date"
            rules={[
              { required: true, message: "Please select a event start date!" },
            ]}
          >
            <DatePicker
              getPopupContainer={(trigger) => trigger.parentNode}
              size="large"
              style={{ width: "100%" }}
            />
          </Form.Item>
          <Form.Item
            name="endDate"
            label="Event End Date"
            rules={[
              { required: true, message: "Please select a event end date!" },
            ]}
          >
            <DatePicker
              getPopupContainer={(trigger) => trigger.parentNode}
              size="large"
              style={{ width: "100%" }}
            />
          </Form.Item>
          <Form.Item
            style={{ marginBottom: "10px" }}
            name="passColor"
            label="Pass Color Hex Code"
            rules={[
              {
                required: true,
                message: "Enter pass color hex code!",
              },
            ]}
          >
            <Input size="large" placeholder="Enter pass color hex code"
              style={{
                border: '1px solid #d9d9d9', // Set a border to avoid global CSS issues
                borderRadius: '4px', // Rounded corners
                padding: '4px', // Padding for better spacing
                width: '100%', // Full width
                boxShadow: 'none', // Remove any shadow
                height: '32px', // Fixed height
              }}
            />
          </Form.Item>
          <Form.Item
            name="regStartDate"
            label="Registration Start Date"
            rules={[{ required: true, message: "Please select event date!" }]}
          >
            <DatePicker
              style={{ width: "100%" }}
              size="large"
              format="DD-MM-YYYY"
              getPopupContainer={(trigger) => trigger.parentNode}
              // disabledDate={(current) => current && current < new Date()} // prevent past dates
            />
          </Form.Item>
          <Form.Item
            name="eventTimeRange"
            label="Event Time (From - To)"
            rules={[{ required: true, message: "Please select time range!" }]}
          >
            <TimePicker.RangePicker
              getPopupContainer={(trigger) => trigger.parentNode}
              format="HH:mm"
              minuteStep={15}
              size="large"
              style={{ width: "100%" }}
            />
          </Form.Item>
          <Form.Item
            name="active"
            label="Status"
            rules={[{ required: true, message: "Please select a status!" }]}
          >
            <Radio.Group>
              <Radio value={true}>Active</Radio>
              <Radio value={false}>Deactive</Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item
            className="modal-buttons"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <Button type="primary" htmlType="submit">
              {edit ? "Update" : "Submit"}
            </Button>
            &nbsp;
            &nbsp;
            <Button onClick={handleClose}>Cancel</Button>
          </Form.Item>
        </Form>
      </Box>
    </Modal>
  );
};

export default UpdateModal;
